// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1790":"dc6bdfef","7443":"8d508dd6"}[chunkId] + ".chunk.css";
};